<template>
  <div id="attribution">
    <div class="cuebiq-panel">
      <div class="cuebiq-panel__body cuebiq-panel__body--no-heading">
        <div class="row">
          <div class="col-xs-12" v-for="(inline, index) in campaign_details.inline" :key="index">
            <div :class="'metric overview-'+inline.title.toLowerCase().replace(/[()]/gi, '').replace(/[-\s]/gi, '_')">
              <div class="metric__icon-container">
                <img class="metric__icon-image" :src="imgBasePath + inline.icon + '.png'" alt="">
              </div>
              <div class="metric__content">
                <h3 class="metric__title">{{ inline.value }}</h3>
                <p class="metric__subtitle">{{ inline.title }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-4" v-for="(col, index) in campaign_details.col" :key="index" v-if="col.value">
            <div :class="'metric overview-'+col.title.toLowerCase().replace(/[()]/gi, '').replace(/[-\s]/gi, '_')">
              <div class="metric__icon-container">
                <img class="metric__icon-image" :src="imgBasePath + col.icon + '.png'" alt="">
              </div>
              <div class="metric__content">
                <h3 class="metric__title">{{ col.value }}</h3>
                <p class="metric__subtitle">{{ col.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'campaign-overview',
    data: function() {
      return {
        campaign_details: {},
        imgBasePath: this.$chartSettings['image_path'] + "attribution/"
      }
    },
    beforeRouteLeave(to, from, next) {
      this.$splashScreen.tabEnabled = true;
      next();
    },
    mounted: function() {
      this.$splashScreen.tabEnabled = false;
      this.$cursorSpinner.processing = false;
      this.$nextTick(() => {
        this.fetchData();
        this.$_am.logEvent("visit",this.$route.name,"campaign-overview",new Date().toISOString())
      });
    },
    methods: {
      fetchData: function () {
        var self = this;
        self.$dataStore.json( "campaign_overview.json", function( data ) {
            self.campaign_details = data;

            self.$reportSettings.setVisibility();
        });
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tabs/CampaignOverview.vue